import React, { useEffect, useRef } from "react";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import Embers from "./Embers";
import { IMAGES, STATS, APPLY_URL } from "../../data/mock";
import { SplitWords } from "./Reveal";

export default function Hero() {
  const imgRef = useRef(null);
  useEffect(() => {
    const on = () => {
      const y = window.scrollY;
      if (imgRef.current) imgRef.current.style.transform = `translate3d(0, ${y * 0.18}px, 0) scale(${1 + y * 0.0003})`;
    };
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <section id="top" className="relative min-h-[100vh] w-full overflow-hidden pt-[72px]">
      {/* Background image */}
      <div className="absolute inset-0">
        <div ref={imgRef} className="absolute inset-0 will-change-transform">
          <img src={IMAGES.heroLift} alt="" className="w-full h-full object-cover object-center opacity-[0.42]" />
        </div>
        <div className="absolute inset-0" style={{ background: "radial-gradient(1200px 700px at 70% 40%, rgba(201,114,42,0.18), transparent 60%), linear-gradient(180deg, rgba(10,9,8,0.4) 0%, rgba(10,9,8,0.75) 55%, rgba(10,9,8,1) 100%)" }} />
        <Embers density={70} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-14 md:pt-20">
        {/* Volume label */}
        <div className="flex items-center gap-4 text-[var(--text-muted)]">
          <span className="h-px w-10 bg-[var(--line-2)]"></span>
          <span className="font-mono text-[10px] uppercase tracking-[0.32em]">Forging Christian Men · Vol. 01</span>
        </div>

        <div className="mt-8 md:mt-12 max-w-[1100px]">
          <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-[var(--ember-3)] mb-6">As iron sharpens iron · Prov. 27:17</div>
          <p className="font-mono text-[12px] uppercase tracking-[0.22em] text-[var(--text-muted)] mb-8">A coaching brotherhood for Christian men.</p>

          <h1 className="font-display font-light text-[11vw] md:text-[8.4vw] lg:text-[7.6vw] leading-[0.94] tracking-[-0.03em]">
            <SplitWords text="Train the man," stagger={70} />
            <br />
            <SplitWords text="not the" stagger={70} />{" "}
            <span className="italic-serif text-[var(--ember-3)]"><SplitWords text="mirror." stagger={70} /></span>
          </h1>
        </div>

        <div className="mt-12 md:mt-16 grid md:grid-cols-[1.2fr_1fr] gap-10 items-end">
          <p className="text-[var(--text-muted)] text-[17px] leading-[1.7] max-w-[540px]">
            The body is a byproduct of the internal work no one sees. Forge the man in private. Watch the mirror catch up.
          </p>
          <div className="flex flex-col md:flex-row gap-4 md:justify-end">
            <a href={APPLY_URL} target="_blank" rel="noreferrer" className="btn-ember">Begin the Application <ArrowUpRight size={16}/></a>
            <a href="#forged-plate" className="btn-ghost"><ArrowDown size={14}/> Get the Free Recipe Guide</a>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-20 md:mt-28 border-t hairline-2 pt-8 grid grid-cols-3 gap-6">
          {STATS.map((s, i) => (
            <div key={i} className="flex flex-col">
              <div className="font-display text-[44px] md:text-[64px] leading-none tracking-tight">{s.k}</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.26em] text-[var(--text-muted)] mt-3">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 right-8 z-10 hidden md:flex items-center gap-3 text-[var(--text-muted)]">
        <span className="font-mono text-[10px] uppercase tracking-[0.28em]">Scroll</span>
        <span className="h-8 w-px bg-[var(--line-2)] relative overflow-hidden"><span className="absolute inset-x-0 top-0 h-3 bg-[var(--ember-2)] animate-[marquee_1.6s_ease-in-out_infinite]" style={{ animation: "scrollDown 1.8s ease-in-out infinite" }}></span></span>
      </div>

      <style>{`@keyframes scrollDown { 0%{transform:translateY(-100%);} 60%{transform:translateY(100%);} 100%{transform:translateY(100%);} }`}</style>
    </section>
  );
}
